"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledChipLabel = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ChipLabelMixin = require("../../mixins/components/ChipLabelMixin");
var StyledChipLabel = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "StyledChipLabel",
  componentId: "c11n-8-107-0__sc-jj6k8p-0"
})(["", ""], _ChipLabelMixin.ChipLabelMixin);
exports.StyledChipLabel = StyledChipLabel;